/**
 * Sierra Leonean leone.
 */
export var SLL = {
  code: 'SLL',
  base: 10,
  exponent: 2
};